import onSuccessRedirectSelectorSelector from 'root/src/client/logic/route/selectors/onSuccessRedirectSelectorSelector'
import setShareUrl from 'root/src/client/logic/static/actions/setShareUrl'
import path from 'ramda/src/path'
import pushRouteClient from 'root/src/client/logic/route/util/pushRouteClient'

export default (res, { moduleKey, moduleId }) => async (dispatch, getState) => {
	const state = getState()
	const { routeId, routeParams } = onSuccessRedirectSelectorSelector(state,
		{ moduleId, submitIndex: 0, moduleKey })
	dispatch(setShareUrl(path(['body', 'shareUrl'], res)))

	return pushRouteClient({ routeId, routeParams })
}
